import { render, staticRenderFns } from "./AuthTabsSwitcher.vue?vue&type=template&id=f896774a&scoped=true&"
import script from "./AuthTabsSwitcher.vue?vue&type=script&lang=ts&"
export * from "./AuthTabsSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./AuthTabsSwitcher.vue?vue&type=style&index=0&id=f896774a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f896774a",
  null
  
)

export default component.exports